/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Button, Box } from "@mui/material";
import { SVGIcons } from "cms/icons/svg-icons";
import useStyles from "cms/fields/_styles";
import { useTranslation } from "react-i18next";

const WebpageAddComponent = (props) => {
    
    const { setOpen } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    
    const onClickAddWebpage = () => {
        setOpen(true);
    };
    
    return (
        <div className='simplicity-composer-helpful'>
            <Box className={classes.boxContainer}>
                <Button
                    color='primary'
                    variant='contained'
                    onClick={onClickAddWebpage}
                >
                    <SVGIcons.common.Create sx={{ marginRight: "8px" }} /> {t("commons.addWebpage")}
                </Button>
            </Box>
        </div>
    );
};

export { WebpageAddComponent };
